(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("odConsumer", [], factory);
	else if(typeof exports === 'object')
		exports["odConsumer"] = factory();
	else
		root["odConsumer"] = factory();
})(window, function() {
return 